module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "alt-font",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadPdf($event)
      }
    }
  }, [_vm._v("↓ Download PDF")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2300321e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/DownloadPdf.vue
// module id = 563
// module chunks = 1